import {
    IFunctionGateway,
    IFunctionMapping,
    IFunctionOptions,
} from '../interfaces';
import { LambdaGatewayService, RestGatewayService } from './gateways';
import { existFunctionMappingTypeConfig } from '../helper';

export class FunctionGatewayFactory {
    static gateway(
        functionName: string,
        params: unknown,
        functionMapping: IFunctionMapping,
        options: IFunctionOptions = {},
    ): IFunctionGateway {
        const isMultiPlatformMode =
            process.env.PLATFORM_TYPE?.toLowerCase() === 'container';

        if (options.mappingType === 'rest') return new RestGatewayService();
        if (options.mappingType === 'lambda') return new LambdaGatewayService();

        if (isMultiPlatformMode) {
            const hasRestConfig = existFunctionMappingTypeConfig(
                functionName,
                functionMapping,
                params,
                'rest',
            );
            if (hasRestConfig) return new RestGatewayService();
        }

        return new LambdaGatewayService();
    }
}
